import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { ITravelBookingProgressBar } from '@shared/shared/interfaces/travel-booking-progress-bar.interfaces';
import { ITravelCarHireSubBooking } from '@shared/shared/interfaces/travel-car-hire.interfaces';
import { ITravelHotelSubBooking } from '@shared/shared/interfaces/travel-hotel.interfaces';
import { ITravelBooking } from '@shared/shared/interfaces/travel.interfaces';
import { TravelSearchToggles } from '@shared/store/models/travel-search-toggles';
import * as fromTravelBookingBar from './travel-booking-progress-bar.reducers';
import * as fromTravelBooking from './travel-booking.reducers';
import * as fromCarHireSubBooking from './travel-car-hire-sub-booking.reducers';
import * as fromFlightSubBooking from './travel-flight-sub-booking.reducers';
import * as fromHotelSubBooking from './travel-hotel-sub-booking.reducers';
import * as fromTravelSearchToggles from './travel-search-toggles.reducers';

export interface TravelBookingState {
  travelBookingBar: ITravelBookingProgressBar;
  travelSearchToggles: TravelSearchToggles;
  travelBooking: ITravelBooking;
  travelCarHireSubBooking: ITravelCarHireSubBooking;
  travelHotelSubBooking: ITravelHotelSubBooking;
  travelFlightSubBooking: fromFlightSubBooking.FlightSubBookingState;
}

export const reducers: ActionReducerMap<TravelBookingState> = {
  travelBookingBar: fromTravelBookingBar.reducer,
  travelSearchToggles: fromTravelSearchToggles.reducer,
  travelBooking: fromTravelBooking.reducer,
  travelCarHireSubBooking: fromCarHireSubBooking.reducer,
  travelHotelSubBooking: fromHotelSubBooking.reducer,
  travelFlightSubBooking: fromFlightSubBooking.reducer,
};

export const getTravelBookingState = createFeatureSelector<TravelBookingState>('travel-booking');
